module.exports = __webpack_public_path__ + "static/media/icon-des.313f0216.svg";